import { render, staticRenderFns } from "./UserForgetPass.vue?vue&type=template&id=4fb6923e&scoped=true&"
import script from "./UserForgetPass.vue?vue&type=script&lang=js&"
export * from "./UserForgetPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb6923e",
  null
  
)

export default component.exports